function TechnicalPlanning(props) {
    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">미디어엔지니어</h4>
                <h5 className="recruit_titleline_title">기술기획팀</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <p className="recruit_subinfo_text">
                    기술기획팀은 여러 부서와 협업을 할 일이 많고 다양한 업무를 주도하여 수행합니다.<br />
                    그렇기 때문에 대부분 기술국 내 여러 부서에서 경험을 쌓고 온 전문가들로 구성되어 있고 파트별로 알맞은 역량이 요구됩니다.<br />
                    다만 원활한 업무 수행을 위해서 전체적으로 아래와 같은 역량들이 갖춰져 있으면 많은 도움이 됩니다.<br />
                </p>
                <ul className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">방송 신호(SDl 등)에 대한 이해</li>
                    <li className="recruit_subinfo_list_inner">IP 네트워크에 대한 기본 지식</li>
                    <li className="recruit_subinfo_list_inner">RF 신호(Radio Frequency)에 대한 기본 지식</li>
                    <li className="recruit_subinfo_list_inner">커뮤니케이션 및 문제 해결 역량</li>
                </ul>
                <p className="recruit_subinfo_text">
                    언급된 역량이 부족하다고 느껴 지원을 망설이시는 분들께는 입사 후 여러 부서의 업무를 경험하면서
                    필요한 지식과 역량을 차근차근<br />쌓아 갈 수 있으니 너무 걱정하지 않으셔도 된다는 말을 전해드리고 싶습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    기술기획팀은 제작부터 송신에 이르는 방송시설 전반의 인프라 기획과 시스템 구축을 주도하고
                    방송에 필요한 장비를 구매하는<br />부서입니다. 또한, 기술과 관련된 외부 기관과의 인터페이스 역할도 수행합니다.<br />
                    <br />
                    기술기획팀은 총 3개의 파트로 구분됩니다.
                </p>
                <em className="recruit_bold_text">방송인프라 기획/구매/관리</em>
                <p className="recruit_subinfo_text">
                    SBS 방송시설 전반의 시설 기획, 노후 교체 계획 등을 수립하여 필요한 방송 장비를 효율적으로 구매하는 역할을 합니다.<br />
                    또한 구매한 장비를 적재적소에 배치하고 관리하는 업무도 수행합니다.
                </p>
                <em className="recruit_bold_text">방송시스템 설계/구축</em>
                <p className="recruit_subinfo_text">
                    SBS 방송시스템의 신규 구축, 시설 전환을 기획하여 설계와 구축 공사를 주도하는 역할을 합니다.<br />
                    또한 빅이벤트(올림픽, 월드컵, 아시안게임 등) 개최 시 방송에 필요한 현지 방송시설 설계와 구축 업무도 수행합니다.
                </p>
                <em className="recruit_bold_text">기술 정책</em>
                <p className="recruit_subinfo_text">
                    기술과 관련된 대관업무(과기부,방통위 등)와 더불어 송·중계소의 치국기획, 인허가 등 행정 관리, 방송재난담당 업무를 수행합니다.<br />
                    또한 기술 동향 파악과 교류를 위해 외부 기관과 협력하는 창구역할도 맡고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    방송인프라 기획, 시스템 설계, 기술정책 전문가 등 다양한 분야의 전문 엔지니어로 성장할 수 있습니다.<br />
                    본인의 적성에 맞는 분야를 찾아 실무를 거치며 깊이 있는 지식과 경험을 얻을 수 있고 방송 기술에 대한 시야를 넓힐 수 있습니다.<br />
                    뿐만 아니라 제작부터 송신, 디지털플랫폼에 이르는 방송 기술 전 사이클과 최근 동향을 직, 간접적으로 알 수 있게 되기 때문에<br />
                    의지와 열정만 있다면 다양한 미디어 영역을 섭렵하는 엔지니어로 발전해 나아갈 수 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    안녕하세요 SBS 기술기획팀에서 기술정책 업무를 맡고 있는 윤여황입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">기술정책 담당자가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    저는 입사 후 네트워크기술팀으로 발령을 받아 주조정실에서 근무를 시작했습니다.<br />
                    주조정실의 송출 업무가 어느 정도 익숙해질 때쯤 회사에서 다양한 경험을 해보고 싶은 생각이 들었고
                    정책이란 단어에 호기심을<br />갖게 되었습니다. SBS 기술국 내 다양한 팀과 직무들이 있지만 ‘정책’과 같이 문과적 냄새(?)를 풍기는 업무는
                    없었기 때문에<br />식견을 넓힐 수 있는 기회가 될 것 같아 일하게 되었습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    주도적으로 프로젝트를 이끌어 좋은 결과물을 냈을 때 보람을 느낍니다.<br />
                    제가 담당하는 업무 중 하나는 송·중계소 등 RF를 기반으로 한 방송시설들의 송신기획과 인허가 등의 행정 관리입니다.<br />
                    RF 시설들의 신규 구축이나 시설 교체 등의 이슈가 생기면 사업 타당성 조사부터 시작해 프로젝트 계획, 설계도서 작성, 인허가 신청,
                    <br />공사 진행, 무선국 검사까지 이루어지는 전 과정을 총괄합니다.<br /><br />
                    이러한 과정은 전문 기술사가 정보통신사업 설계를 진행하는 과정과 비슷하여 많은 부분을 검토하고 공부하기 때문에
                    하나의 프로젝트를<br />완성하고 나면 여러 면에서 성장한 모습을 확인할 수 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    방송과 관련된 기술분야의 다양한 업무를 경험해보고 본인에게 맞는 일을 선택하여 전문가로 성장하는 것이 가능합니다.<br />
                    본인의 의지와 역량만 있다면 많은 경험과 기회를 얻을 수 있는 곳이기 때문에 성장하고 싶은 사람에게 더욱 좋은 직장이라고 생각합니다.<br />
                    근무 환경도 좋습니다. 본인이 맡은 업무와 시기에 따라 다르겠지만 대부분 퇴근 후의 삶을 즐길 수 있을 만큼 워라밸이 좋은 편입니다.<br />
                    안정적인 업무 환경을 바탕으로 지나친 경쟁보다는 함께하는 분위기가 있으며, 똑똑한 사람이 많아 함께 일하는 선후배들에게 많은 것을<br />배울 수 있습니다.
                </p>
            </div>
        </div>
    );
}

export default TechnicalPlanning;